import React from 'react'
import { DotProps } from 'react-multi-carousel'

import { Plan } from '../../types'

interface Props extends DotProps {
  currentPlans: Plan[]
}

const CustomDot: React.FC<Props> = ({ index, active, onClick, currentPlans }) => {
  const plan = currentPlans[index || 0]

  return (
    <button className={`plans__select ${active && 'plans__select--active'}`} onClick={onClick}>
      {plan.planBoxTitle}
    </button>
  )
}

export default CustomDot
